export default {"src":"/_next/static/media/Reddit.93eeb3c8.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};